// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/Navin_snap_2022_1-1-2-285x300.jpg"



function Faculty() {


    return (
        <div className="min-h-screen bg-white">
            

            <div className="flex flex-col items-center  min-h-screen p-4 w-full font-serif">
                {/* Profile Image */}
                <img
                    src={img1}
                    alt="img1"
                    className="w-72 h-72 rounded shadow mb-4 mt-4"
                />

                {/* Profile Info */}
                <div className="max-w-3xl text-center text-black">
                    {/* Name */}
                    <p className="font-semibold text-2xl mb-2">
                    Dr. Navin Kumar
                    </p>

                    {/* Email */}
                    <p className="font-semibold text-2xl mb-4 text-gray-600">
                    nkumar@iitrpr.ac.in
                    </p>

                    {/* Title */}
                    <h5 className="w-full text-base mb-4 text-2xl text-gray-600">
                    Professor <br />
                        Department of Mechanical Engineering and Biomedical Engineering <br />
                        Indian Institute of Technology Ropar
                    </h5>

                </div>
               
            </div>




        </div>
    );
}

export default Faculty;
